export default {"src":"/_next/static/media/drone_40.c8c926e9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};